import { createApp } from "vue";
import App from "./App.vue";
import axios from "./utils/axios";
import router from "./router";
import moment from "moment";
import store from "./store";
import Swal from "sweetalert2";
import "@/assets/tailwind.css";

const app = createApp(App);
app.use(store);
app.use(router);
app.provide("$router", router);
app.provide("$axios", axios);
app.provide("$moment", moment);
app.provide("$store", store);
app.provide("$swal", Swal);
app.mount("#app");